import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";
import { AuthenticationService } from "src/app/services/authentication.service";
import { ParcelTrackerRoleEnum } from "src/app/shared/generated/enum/parcel-tracker-role-enum";

/**
 * Mirrors the legacy ParcelPermitViewFeature (ParcelPermitConsultant, MOUPartner, StateLands, Power,
 * Admin). Keeps the Parcel Permits index page hidden from Unassigned/Normal/ReadOnly and anonymous
 * users who would otherwise reach it directly by URL — the nav menu item is already gated by the same
 * role set (parcels-layout `canViewParcelPermits`), but the route had no guard.
 */
@Injectable({ providedIn: "root" })
export class ParcelPermitsAccessGuard implements CanActivate {
    private static readonly ALLOWED_ROLES = [
        ParcelTrackerRoleEnum.Admin,
        ParcelTrackerRoleEnum.Power,
        ParcelTrackerRoleEnum.StateLands,
        ParcelTrackerRoleEnum.MOUPartner,
        ParcelTrackerRoleEnum.ParcelPermitConsultant,
    ];

    constructor(private authenticationService: AuthenticationService, private router: Router) {}

    canActivate(): Observable<boolean> {
        return this.authenticationService.getCurrentUser().pipe(
            take(1),
            map((user) => {
                const role = user?.ParcelTrackerRoleID;
                const allowed = role != null && ParcelPermitsAccessGuard.ALLOWED_ROLES.includes(role);
                if (!allowed) {
                    this.router.navigate(["/moorings/inventory"]);
                    return false;
                }
                return true;
            }),
        );
    }
}
